<template>
  <div>
    <b-form @submit.prevent="submit">
      <b-form-group>
        <requiredComponent
          slot="label"
          :label="$lang.parvandeh"
          :rules="$v.parvandeh_selected.$params"
        />
        <selectAsync
          :options="parvandeh_options"
          v-model="$v.parvandeh_selected.$model"
          label="caption"
          id="id"
          :disabled="mode === 'EDIT'"
          :asyncFind="getParvandehCombo"
          :isValid="
            $v.parvandeh_selected.$dirty ? !$v.parvandeh_selected.$error : null
          "
          :loading="parvandeh_loading"
          @input="getTermStateCombo"
        />
        <b-form-invalid-feedback
          :state="
            $v.parvandeh_selected.$dirty ? !$v.parvandeh_selected.$error : null
          "
        >
          <div v-if="!$v.parvandeh_selected.required">
            {{ $lang.error_required | replace($lang.parvandeh) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <requiredComponent
          slot="label"
          :label="$lang.term_state"
          :rules="$v.term_state_selected.$params"
        />
        <selectFind
          :options="term_state_options"
          v-model="$v.term_state_selected.$model"
          label="caption"
          id="id"
          :disabled="mode === 'EDIT'"
          :loading="term_state_loading"
          :isValid="
            $v.term_state_selected.$dirty
              ? !$v.term_state_selected.$error
              : null
          "
        />
        <b-form-invalid-feedback
          :state="
            $v.term_state_selected.$dirty
              ? !$v.term_state_selected.$error
              : null
          "
        >
          <div v-if="!$v.term_state_selected.required">
            {{ $lang.error_required | replace($lang.term_state) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <requiredComponent
          slot="label"
          :label="$lang.payment_off_percent"
          :rules="$v.payment_off_percent.$params"
        />
        <b-form-input
          v-model="$v.payment_off_percent.$model"
          type="text"
          minLength="1"
          maxLength="3"
          autocomplete="off"
          :state="
            $v.payment_off_percent.$dirty
              ? !$v.payment_off_percent.$error
              : null
          "
        />
        <b-form-invalid-feedback
          :state="
            $v.payment_off_percent.$dirty
              ? !$v.payment_off_percent.$error
              : null
          "
        >
          <div v-if="!$v.payment_off_percent.required">
            {{ $lang.error_required | replace($lang.payment_off_percent) }}
          </div>
          <div v-if="!$v.payment_off_percent.numeric">
            {{ $lang.error_numeric | replace($lang.payment_off_percent) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <requiredComponent
          slot="label"
          :label="$lang.description"
          :rules="$v.description.$params"
        />
        <b-form-textarea
          id="description"
          type="text"
          v-model="$v.description.$model"
          :state="$v.description.$dirty ? !$v.description.$error : null"
          :autocomplete="$lang.description"
          :rows="this.$config.form.textareaRows"
        ></b-form-textarea>
        <b-form-invalid-feedback id="description-feedback"
          >{{ $lang.error_required | replace($lang.description) }}
        </b-form-invalid-feedback>
      </b-form-group>
      <div slot="footer" class="form-group form-btn">
        <b-button
          type="reset"
          class="mr-2"
          variant="outline-danger"
          @click="close"
        >
          <mdicon name="close" size="20" />
          {{ $lang.cancelButton }}
        </b-button>
        <b-button type="submit" v-if="isAdmin(permissions)" variant="success">
          <mdicon name="check" size="20" />
          {{ $lang.azmoonLang.submitButton }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "payment-no-need-form",
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: "ADD",
    },
  },
  validations: {
    parvandeh_selected: { required: requiredIf((vm) => vm.mode === "ADD") },
    term_state_selected: { required: requiredIf((vm) => vm.mode === "ADD") },
    payment_off_percent: { required, numeric },
    description: { required },
  },
  data() {
    return {
      term_state_selected: null,
      term_state_options: [],
      term_state_loading: false,
      parvandeh_loading: false,
      parvandeh_options: [],
      parvandeh_selected: null,
      payment_off_percent: null,
      description: null,
    };
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    async getParvandehCombo(query) {
      if (!query || query.length < 2) return;
      if (query.length > 2) {
        this.parvandeh_options = [];
      }
      try {
        this.parvandeh_loading = true;
        const url = generateApiUrl(["profile", "parvandeh_combo"]);
        const queryString = {
          search_txt: query,
          type: 1,
        };
        const response = await this.$httpService.get(url, queryString);
        const data = pathOr([], ["data", "data"], response);
        this.parvandeh_options = data.map((x) => {
          return {
            caption: `${pathOr("", ["parvandeh_number"], x)} - ${pathOr(
              "",
              ["person", "name"],
              x
            )} ${pathOr("", ["person", "family"], x)} - ${pathOr(
              "",
              ["term", "caption"],
              x
            )}`,
            id: pathOr(null, ["parvandeh_code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.parvandeh_loading = false;
      }
    },
    async getTermStateCombo(item) {
      try {
        this.term_state_loading = true;
        const parvandehCode = pathOr(null, ["id"], item);
        if (!parvandehCode) return;
        const url = generateApiUrl(["report", "term_state_combo"], [], {
          parvandeh_code: parvandehCode,
          state_name: "payment",
        });
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.term_state_options = data.map((item) => {
          return {
            id: pathOr(null, ["code"], item),
            caption: pathOr(null, ["state_caption"], item),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.term_state_loading = false;
      }
    },
    removeReportSettingSelected(item) {
      this.report_settings_selected = [
        ...this.report_settings_selected.filter((row) => row.id !== item.id),
      ];
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      if (this.payment_off_percent < 1 || this.payment_off_percent > 100) {
        return this.$notify.warning("درصد تخفیف باید عددی بین 1 تا 100 باشد.");
      }

      const payload = {
        parvandeh_code: pathOr(null, ["id"], this.parvandeh_selected),
        term_state_code: pathOr(null, ["id"], this.term_state_selected),
        payment_off_percent: this.payment_off_percent,
        description: this.description,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (this.item) {
        const parvandehData = {
          caption: `${pathOr(
            "",
            ["parvandeh", "parvandeh_number"],
            this.item
          )} - ${pathOr(
            "",
            ["parvandeh", "person", "full_name"],
            this.item
          )} - ${pathOr("", ["parvandeh", "term", "caption"], this.item)}`,
          id: pathOr(null, ["parvandeh", "code"], this.item),
        };
        this.parvandeh_selected = parvandehData;
        this.parvandeh_options = [parvandehData];

        const termStateData = {
          id: pathOr(null, ["term_state", "code"], this.item),
          caption: pathOr(null, ["term_state", "caption"], this.item),
        };
        this.term_state_selected = termStateData;
        this.term_state_options = [termStateData];

        this.payment_off_percent = pathOr(
          null,
          ["payment_off_percent"],
          this.item
        );
        this.description = pathOr("", ["description"], this.item);
      }
    },
  },
};
</script>
